import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { HeaderService } from "../services/header.service";

@Injectable()
export class RequestSubmitService {
  constructor(private http: HttpClient, public headerService: HeaderService) {}

  getRequestForDisplay(requestId: string) {
    return this.http.get(`/api/Request/getRequestForDisplay`, {
      params: { requestId: requestId },
      responseType: "json"
    });
  }

  getRequestStatusCodeById(requestStatusCodeId: string) {
    return this.http.get(`/api/RequestStatusCode/getRequestStatusCodeById`, {
      params: { type: requestStatusCodeId },
      responseType: "json"
    });
  }

  getConsultantIdByNm(consultantNm: string) {
    return this.http.get(`/api/Consultant/getConsultantIdByNm`, {
      params: { type: consultantNm },
      responseType: "json"
    });
  }

  /**
   * @description Takes in the status code name and returns status code Id
   * @requires REQUEST_STATUS_CODE_NM
   * @returns REQUEST_STATUS_CODE_ID
   */
  getRequestStatusCodeIdByNm(requestStatusCodeNm: string) {
    return this.http.get(`/api/RequestStatusCode/getRequestStatusCodeIdByNm`, {
      params: { type: requestStatusCodeNm },
      responseType: "json"
    });
  }

  getSpecByAcc(accommId: string) {
    return this.http.get(`/api/AuthCode/getSpecCodeByAccId`, {
      params: { type: accommId },
      responseType: "json"
    });
  }

  updateRequestForConfirm(data: any) {
    return this.http.put(`/api/Request/updateRequestForConfirm`, data, {
      observe: "response"
    });
  }

  /**
   * @description Sets the locked_fl to 1 for the Person_Plan row so that the examinee's plan might not be changed while
   * it is being reviewed by internal staff.
   * @requires PERSON_ID
   */
  lockPersonPlan(data: any) {
    return this.http.put(`/api/PersonPlan/lockPersonPlan`, data, {
      observe: "response"
    });
  }

  /**
   * @description Sets the locked_fl to 1 for the Person_Disability row so that the examinee's disability might not be changed while
   * it is being reviewed by internal staff.
   * @requires PERSON_ID
   */
  lockPersonDisability(data: any) {
    return this.http.put(`/api/PersonDisability/lockPersonDisability`, data, {
      observe: "response"
    });
  }

  /**
   * @description Sets the locked_fl to 1 for the Person_Document row so that the examinee's documentation might not be changed while
   * it is being reviewed by internal staff.
   * @requires PERSON_ID
   */
  lockPersonDocument(data: any) {
    return this.http.put(`/api/PersonDocument/lockPersonDocument`, data, {
      observe: "response"
    });
  }

  checkForRequestRouting(data: any) {
    return this.http.post("/api/getRequestRoutingCondition", data, {
      responseType: "json"
    });
  }

  updateRequestForRouting(data: any) {
    return this.http.put(`/api/Request/updateRequestForRouting`, data, {
      observe: "response"
    });
  }

  updateRequestAccommodationForRoute(data: any) {
    return this.http.put(
      `/api/ReqAccoms/updateRequestAccommodationForRouting`,
      data,
      { observe: "response" }
    );
  }

  /**
   * @description Used to update a singe requested accommodation from one status to another.
   * @requires REQUEST_ID
   * @requires REQUESTED_ACCOMMODATION_ID
   */
  updateRequestAccommodationStatus(data: any) {
    return this.http.put(`/api/ReqAccoms/updateReqAccommStatus`, data, {
      observe: "response"
    });
  }

  postReviewDetail(data: any) {
    return this.http.post(`/api/ReviewDetail/createReviewDetail`, data, {
      observe: "response"
    });
  }

  postReviewDetailAccommStatus(data: any) {
    return this.http.post(
      `/api/reviewDetailAccommStatus/createReviewDetailAccStatus`,
      data,
      { observe: "response" }
    );
  }

  postRequestAccommDecisionCode(data: any) {
    return this.http.post(
      `/api/requestAccommDecisionCode/postRequestAccommCode`,
      data,
      { observe: "response" }
    );
  }

  createRequestComment(data: any) {
    return this.http.post(`/api/RequestComment/createRequestComment`, data, {
      observe: "response"
    });
  }

  getRequestCommentsById(requestId: string) {
    return this.http.get(`/api/RequestComment/getRequestCommentById`, {
      params: { type: requestId },
      responseType: "json"
    });
  }

  /**
   * @description Create the decision document.
   * @requires
   * @requires
   */
  postReviewFile(data: any) {
    return this.http.post(`/api/ReviewDetail/createReviewFile`, data, {
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/requestsubmit.service.ts